export const environment = {
  production: true,
  versionCheckURL : '/version.json',

  turnstile: {
    siteKey: '0x4AAAAAAB_l9-dJ-IGaBTXD',
  },
  api: {
    baseUrl: 'https://pricing-api.glichealth.com/api/v3/',
    version: 'v3',
    timeout: 30000,
    retryAttempts: 3,
    enableLogging: false
  },
  googleMaps: {
    // TODO: Replace with your actual Google Maps JavaScript API key
    apiKey: 'AIzaSyBNihkxqgTOPI88D4-CfGUz-lOvtu_ceaA'
  },
    assetsURL:{
    assetsPath: 'https://cdn.glichealth.com/glicrx/assets/'
  }
};
